export const noEmptySpace = '.*\\S.*';
